// Silence debug output in production builds. console.warn / console.error are kept
// so real problems still show up in the browser console and error tracking.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
}
